module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 28.382 33.503",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }